import { RouterProvider } from '@tanstack/react-router'
import { initPostHog } from '@turfchale/analytics'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { router } from './router'
import './index.css'

initPostHog(import.meta.env.VITE_POSTHOG_KEY ?? '')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
